import styled from 'styled-components';
import tw from 'twin.macro';

const TableCell = styled.td`
  ${tw`p-2 border-r border-gray-300 last:border-r-0`}
`;

const SellerSignsTableRow = styled.tr`
  ${tw`mt-8 flex flex-row justify-between`}
`;

const SellerSignsTableCell = styled(TableCell)`
  ${tw`text-base`}
`;

const SellerSignatureComponent = () => {
  return (
    <SellerSignsTableRow>
      <SellerSignsTableCell>Seller Signs ______________________</SellerSignsTableCell>
      <SellerSignsTableCell>Date ______________________</SellerSignsTableCell>
      <SellerSignsTableCell>By X________________________</SellerSignsTableCell>
      <SellerSignsTableCell>Title ______________________</SellerSignsTableCell>
    </SellerSignsTableRow>
  );
};

export default SellerSignatureComponent;
